import { render, staticRenderFns } from "./WalletListTotals.vue?vue&type=template&id=0927211e&scoped=true"
import script from "./WalletListTotals.vue?vue&type=script&lang=js"
export * from "./WalletListTotals.vue?vue&type=script&lang=js"
import style0 from "./WalletListTotals.vue?vue&type=style&index=0&id=0927211e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927211e",
  null
  
)

export default component.exports